<div class="vd-row" [class.is-compact]="compact" [class.is-playing]="playing">
    <span class="vd-row-index" aria-hidden="true">{{ index + 1 }}</span>
    <button type="button" class="vd-row-thumb" [disabled]="!access?.canPlay || access?.saleNotStarted" (click)="onThumbnail()"
        [attr.aria-label]="'Play ' + (info.stage || 'video')">
        <app-vd-thumb [info]="info" [fallback]="fallbackImage"></app-vd-thumb>
        <span class="vd-row-play" *ngIf="access?.canPlay && !access?.saleNotStarted && !inPlayer"><app-vd-icon name="play"></app-vd-icon></span>
        <span class="vd-chip-dark vd-row-duration" *ngIf="info.duration">{{ info.duration }}</span>
    </button>

    <div class="vd-row-body">
        <div class="vd-row-title">{{ info.stage }}</div>
        <div class="vd-row-meta">
            <span class="vd-now" *ngIf="access?.canPlay && playing" [class.is-still]="playState !== 'playing'" role="status">
                <span class="vd-eq" aria-hidden="true"><i></i><i></i><i></i></span> {{ stateLabel }}
            </span>
            <span class="vd-next" *ngIf="next && !playing">Next</span>
            <span class="vd-badge" *ngIf="badge" [matTooltip]="info.ageInfo" matTooltipPosition="above">{{ badge }}</span>
            <span *ngIf="showCount(info.user_views)" [matTooltip]="(info.user_views | number) + (info.user_views == 1 ? ' view' : ' views')">
                {{ info.user_views | abbreviatedNumber }} {{ info.user_views == 1 ? 'view' : 'views' }}
            </span>
        </div>
    </div>

    <div class="vd-row-actions">
        <!-- Access buttons: same rules and handlers as the classic video list -->
        <span class="vd-btn vd-btn-ghost is-disabled" *ngIf="access?.saleNotStarted" matTooltip="Sale not started yet">
            <app-vd-icon name="clock"></app-vd-icon> Soon
        </span>
        <ng-container *ngIf="!access?.saleNotStarted">
            <!-- id playVideo<id>: shared links (?id=) auto-click it, same as the classic page -->
            <button type="button" class="vd-btn vd-btn-accent vd-btn-play" *ngIf="access?.canPlay && !inPlayer" [id]="'playVideo' + info.id"
                aria-label="Play" [matTooltip]="compact ? 'Play' : ''" matTooltipPosition="above" (click)="play.emit(element)"
                [disabled]="starting" [attr.aria-busy]="starting">
                <span class="vd-spinner vd-spinner-sm" *ngIf="starting; else rowPlayIcon"></span>
                <ng-template #rowPlayIcon><app-vd-icon name="play"></app-vd-icon></ng-template><span class="vd-btn-text">Play</span>
            </button>
            <!-- The video in the player: pause / resume it from the list -->
            <button type="button" class="vd-btn vd-btn-accent vd-btn-play" *ngIf="access?.canPlay && inPlayer" [attr.aria-label]="toggleLabel"
                [matTooltip]="compact ? toggleLabel : ''" matTooltipPosition="above" [disabled]="playState === 'loading'" (click)="togglePlay.emit()">
                <app-vd-icon [name]="playState === 'playing' ? 'pause' : 'play'"></app-vd-icon><span class="vd-btn-text">{{ toggleLabel }}</span>
            </button>
            <span class="vd-btn vd-btn-ghost is-disabled" *ngIf="access?.previewPlay"><app-vd-icon name="play"></app-vd-icon> Play</span>
            <!-- Buy shows the track's price ("Buy · $1.00"); in the compact side panel only the price, like Play's icon-only button -->
            <ng-container *ngIf="{ price: element | vdTrackPrice: tickets } as p">
            <span class="vd-btn vd-btn-ghost is-disabled vd-btn-buy" *ngIf="access?.previewBuy" [class.has-price]="!!p.price"
                [attr.aria-label]="p.price ? 'Buy for ' + p.price : null">
                <app-vd-icon name="buy"></app-vd-icon><span class="vd-btn-text">Buy<ng-container *ngIf="p.price"> ·</ng-container></span><span *ngIf="p.price">{{ p.price }}</span>
            </span>
            <button type="button" class="vd-btn vd-btn-accent vd-btn-buy" *ngIf="access?.buy" [id]="'playVideo' + info.id" (click)="buy.emit(element)"
                [class.has-price]="!!p.price" [attr.aria-label]="p.price ? 'Buy for ' + p.price : null"
                [matTooltip]="compact && p.price ? 'Buy for ' + p.price : ''" matTooltipPosition="above">
                <app-vd-icon name="buy"></app-vd-icon><span class="vd-btn-text">Buy<ng-container *ngIf="p.price"> ·</ng-container></span><span *ngIf="p.price">{{ p.price }}</span>
            </button>
            </ng-container>
            <span class="vd-btn vd-btn-ghost is-disabled" *ngIf="access?.previewSubscribe"><app-vd-icon name="subscribe"></app-vd-icon> Subscribe</span>
            <button type="button" class="vd-btn vd-btn-accent" *ngIf="access?.subscribe" [id]="'playVideo' + info.id" (click)="subscribe.emit(element)">
                <app-vd-icon name="subscribe"></app-vd-icon> Subscribe
            </button>
            <span class="vd-btn vd-btn-ghost is-disabled" *ngIf="access?.planInsufficient" [id]="'playVideo' + info.id"
                matTooltip="Your current subscription plan is not sufficient for this video" matTooltipPosition="above">
                <app-vd-icon name="lock"></app-vd-icon> Upgrade plan
            </span>
            <span class="vd-btn vd-btn-ghost is-disabled" *ngIf="access?.albumLocked" [id]="'playVideo' + info.id"
                matTooltip="Complete album payment to play the video" matTooltipPosition="above">
                <app-vd-icon name="lock"></app-vd-icon> Locked
            </span>
        </ng-container>

        <!-- Small actions stay together: if the row wraps, they move as one group -->
        <span class="vd-row-tools">
            <button type="button" class="vd-icon-btn" *ngIf="access?.canLike" [class.is-active]="liked"
                [attr.aria-pressed]="liked" aria-label="Like" (click)="like.emit({ element: element, index: index })">
                <app-vd-icon name="like" [filled]="liked"></app-vd-icon>
                <span *ngIf="showCount(info.user_likes)">{{ info.user_likes | abbreviatedNumber }}</span>
            </button>

            <button type="button" class="vd-icon-btn" aria-label="Share" matTooltip="Share" matTooltipPosition="above"
                (click)="share.emit({ element: element, anchor: $event.currentTarget })"><app-vd-icon name="share"></app-vd-icon></button>

            <div class="dropdown d-inline-block" *ngIf="access?.canAddToPlaylist">
                <button type="button" class="vd-icon-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-label="Add to playlist" matTooltip="Add to playlist" matTooltipPosition="above">
                    <app-vd-icon name="playlist"></app-vd-icon>
                </button>
                <div class="dropdown-menu dropdown-menu-right vd-menu">
                    <div class="dropdown-item pointer" (click)="createPlaylist.emit()">Create New Playlist</div>
                    <div class="dropdown-item pointer" *ngFor="let playList of playListAry"
                        (click)="addToPlaylist.emit({ element: element, playList: playList })">{{ playList.playlist_name }}</div>
                </div>
            </div>

            <!-- Report is the only option, so it is a direct button (same handler as the classic menu item) -->
            <button type="button" class="vd-icon-btn" aria-label="Report" matTooltip="Report" matTooltipPosition="above"
                [disabled]="isPreview" (click)="report.emit(element)"><app-vd-icon name="report"></app-vd-icon></button>
        </span>
    </div>
</div>
